export default __webpack_public_path__ + "static/media/StephaniePena.e0c9f1f5.jpg";